<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel">
    <app-banner-footer-pages [title]="title1"></app-banner-footer-pages>
    <div class="documentsPageFormSec">
      <app-main-heading [title]="title"></app-main-heading>

      <form>
        <div class="innerpageContent validationdetailspage">
          <div class="row">
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <select
                    name="pre"
                    id="pre"
                    class="regSelect"
                    formControlName="salutationId"
                  >
                    <option [ngValue]="2">Miss</option>
                    <option [ngValue]="1">Mrs</option>
                  </select>
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="name"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="name" class="inputLabel">First Name</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="lastName"
                  placeholder=""
                />
                <label for="lastName" class="inputLabel">Last Name</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  type="email"
                  formControlName="emailId"
                  class="inputBox"
                  id="emailId"
                  placeholder=""
                />
                <label for="emailId" class="inputLabel">Email ID</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="Mobile"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="mobile"
                      placeholder=""
                    />
                    <label for="mobile" class="inputLabel"
                      >Mobile Number
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="EducationQualification"
                  class="inputBox"
                  id="EducationQualification"
                  placeholder=""
                />
                <label for="EducationQualification" class="inputLabel"
                  >Education Qualification</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="dob"
                  placeholder=""
                />
                <label for="dob" class="inputLabel">Date Of Birth</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="BusinessEmail"
                  placeholder=""
                />
                <label for="BusinessEmail" class="inputLabel"
                  >Business Email ID</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="CustomerEmail"
                  placeholder=""
                />
                <label for="CustomerEmail" class="inputLabel"
                  >Customer Support Email ID</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="Businessmobile"
                      placeholder=""
                    />
                    <label for="Businessmobile" class="inputLabel"
                      >Business Number</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="CustomerSupportmobile"
                      placeholder=""
                    />
                    <label for="CustomerSupportmobile" class="inputLabel"
                      >Customer Support Number</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="WhatsAppmobile"
                      placeholder=""
                    />
                    <label for="WhatsAppmobile" class="inputLabel"
                      >WhatsApp Number</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="WebURL"
                  placeholder=""
                />
                <label for="WebURL" class="inputLabel">Website URL</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="pincode"
                  placeholder=""
                />
                <label for="pincode" class="inputLabel">Pincode</label>
              </div>
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="city"
                  placeholder=""
                />
                <label for="city" class="inputLabel">City</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <textarea
                  id="personalAddress"
                  formControlName="desc"
                  rows="8"
                  placeholder=""
                  class="inputBox regTextarea contareaheight"
                ></textarea>
                <label for="personalAddress" class="inputLabel"
                  >Personal Address</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="state"
                  placeholder=""
                />
                <label for="state" class="inputLabel">State</label>
              </div>
            </div>
          </div>
        </div>
      </form>
      <app-main-heading [title]="title2"></app-main-heading>
      <div class="document-validation-page">
        <div class="documents">
          <section class="document-type">
            <div class="doc-type-btn">pan</div>
            <div class="doc-type-btn">gst</div>
            <div class="doc-type-btn">fssai</div>
            <div class="doc-type-btn">health trade</div>
          </section>
          <div class="document-image">
            <img
              class="docFullImage"
              src="../../../assets/images/doc-img.svg"
              alt=""
            />
            <img
              class="docSmallImage"
              src="../../../assets/images/doc-sm.svg"
              alt=""
            />
          </div>
        </div>
        <div class="document-detail">
          <div class="row g-2 g-lg-4">
            <div class="col-lg-6 co-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <select
                    name="pre"
                    id="pre"
                    class="regSelect"
                    formControlName="salutationId"
                  >
                    <option [ngValue]="2">Miss</option>
                    <option [ngValue]="1">Mrs</option>
                  </select>
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="name2"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="name2" class="inputLabel">First Name</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 co-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="lastName2"
                  placeholder=""
                />
                <label for="lastName2" class="inputLabel">Last Name</label>
              </div>
            </div>
            <div class="col-lg-8 co-8">
              <div class="document-acceptence">
                <div class="accptence-text">Document Acceptance</div>
                <label class="switch">
                  <input type="checkbox" id="togBtn" />
                  <div class="slider round">
                    <span class="on">YES</span>
                    <span class="off">NO</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="col-lg-4 co-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Reason </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <!-- <div class="col-lg-12">
            <div class="document-acceptence">
              <div class="accptence-text">Add Expiry Date</div>
              <label class="switch">
                <input type="checkbox" id="togBtn" />
                <div class="slider round addExpire">
                  <span class="on">YES</span>
                  <span class="off">NO</span>
                </div>
              </label>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="inputGroup">
              <input
                type="date"
                min="1960-01-01"
                max="2007-01-01"
                formControlName="dob"
                class="inputBox addExpireDate"
                id="dob"
                placeholder=""
              />
              <label for="dob" class="inputLabel">(FSSAI) expiry Date</label>
            </div>
          </div> -->
          </div>
        </div>
      </div>
      <div class="remark">
        <h3 class="reason remarkTitle">Remarks/Comments</h3>
        <div class="row">
          <div class="col-lg-12">
            <div class="inputGroup">
              <textarea
                id="addreg"
                formControlName="desc"
                rows="8"
                placeholder=""
                class="inputBox regTextarea remarkreaheight"
              ></textarea>
              <label for="addreg" class="inputLabel">Enter remarks.....</label>
            </div>
          </div>
        </div>
      </div>
      <div class="reasons">
        <h3 class="reason">Reasons</h3>
        <ol class="resonsList">
          <li>Lorem ipsum dolor sit amet consectetur.</li>
          <li>
            In elit sem pellentesque morbi adipiscing urna malesuada proin.
          </li>
          <li>A dictumst non nulla a enim arcu non.</li>
          <li>
            Velit cursus tristique netus odio bibendum blandit. Justo commodo
            dignissim est vitae.
          </li>
        </ol>
        <div class="reason-btn-box">
          <div class="reasonButtons">
            <div class="reason-btn res-orange">Follow Up</div>
            <div class="reason-btn res-yellow">Escalate</div>
            <div class="reason-btn res-green">Approve</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
